module.exports = __webpack_public_path__ + "static/media/matt.57d8d0aa.jpg";